import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const EnviosResumenGeneral = ({ data }) => {
    const { isLoading } = useSelector((state) => state.envios);
    const [totalResumen, setTotalResumen] = useState(0);

    useEffect(() => {
        if (data) {
          const total = data.reduce((acc, state) => 
              acc + state.count_nacional + state.count_internacional, 0
          );
          setTotalResumen(total);
        }
    }, [data]);

    return (
        <div className="envio-resumen-general">
            {isLoading ? (
                <>
                  <div className='envio-resumen-general__row row-titles skeleton-container'>
                      {Array.from({ length: 10 }).map((_, i) => (
                                    <span key={i} />
                                  ))}
                  </div>
                  <div className='envio-resumen-general__row row-results skeleton-container'>
                      {Array.from({ length: 10 }).map((_, i) => (
                                    <span key={i} />
                                  ))}
                  </div>
                </>
            ) : (
                <>
                    <div className="envio-resumen-general__row row-titles">
                        <span>Envíos Totales</span>
                        {data?.map((state) => (
                            <span key={`title-${state.estado_id}`}>
                                {state.nombre}
                            </span>
                        ))}
                    </div>

                    <div className="envio-resumen-general__row row-results">
                        <span>{totalResumen}</span>
                        {data?.map((state) => (
                            <span key={`result-${state.estado_id}`}>
                                {state.count_nacional +
                                    state.count_internacional}
                            </span>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};
